import React, { Component } from 'react';
import Select from 'react-select';

import services from './data';

let CategoryOptions = [];

class LubesCategoryList extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      options: [],
    };
  }
  componentDidMount() {
    services
      .getLubesCategoryList()
      .then((response) => {
        const tmp = response.data.data;
        CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].uuid,
            label: tmp[i].name,
          });
        }

        this.setState({ options: CategoryOptions });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  handleChange = (selectedOption) => {
    const i = this.props.did ? this.props.did : 0;
    let option = selectedOption;
    if (selectedOption == null) {
      option = { value: '', label: '' };
    }
    this.props.handleDropdownChange(option, i);
  };

  render() {
    const { options } = this.state;
    return (
      <Select
        onChange={this.handleChange}
        options={options}
        isClearable={true}
        className="select-box-container"
        classNamePrefix="raw-select"
        name="bank"
        placeholder="Select category"
        value={options.filter(({ value }) => value === this.props.value)}
      />
    );
  }
}

export { LubesCategoryList };
